/* eslint-disable max-len */
import React from 'react'
import PatientTable from './PatientTable'

function ProviderPatientList({user_id,
    data,
    patientAssociatedTrigger,
    isFetching,
    providerData,
    status,
    changeProviderAccess,
    setChangeProviderAccess,
    setIsAnyFieldFilled,
    sendAlert,
    setSendAlert,
    setIsProviderAddOrDelete,
    handleDeleteAssociatedPatient,
    fetchPageAndLimit,
    queryParams,
    setQueryParams,
    pageItems,
    setPageItems
}) {
    return (
        <div className='bg-[#00000008] rounded-lg px-2 mb-[28px]'>
            <p id={'provider_patient_dattest'} className='text-base font-semibold text-[#972E4C] px-1.5 py-[22px] '>Patient List</p>
            <PatientTable 
                user_id={user_id}
                data={data}
                providerData={providerData}
                patientAssociatedTrigger={patientAssociatedTrigger}
                status={status}
                isFetching={isFetching}
                changeProviderAccess={changeProviderAccess}
                setChangeProviderAccess={setChangeProviderAccess}
                sendAlert={sendAlert}
                setSendAlert={setSendAlert}
                setIsAnyFieldFilled={setIsAnyFieldFilled}
                setIsProviderAddOrDelete={setIsProviderAddOrDelete}
                handleDeleteAssociatedPatient={handleDeleteAssociatedPatient}
                fetchPageAndLimit={fetchPageAndLimit}
                queryParams={queryParams}
                setQueryParams={setQueryParams}
                pageItems={pageItems}
                setPageItems={setPageItems}
            />    
        </div>
    )
}

export default ProviderPatientList